var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"in_date","sortable":"","label":"Bekerülés dátum","min-width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(_vm._f("date")(scope.row.in_date))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }